import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useEffect,useState,useRef } from "react";
import axios from "axios";
import { instituteInfo, allBlogs } from '../../Data/BlogData';
import '../../Component/blog.css';


const BlogDetail = () => {
  const { instituteId, blogSlug } = useParams();
  const form = useRef(); // Create a reference for the form
  const [isSending, setIsSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");


  const info = instituteInfo[instituteId];
  const blog = allBlogs.find(b => b.slug === blogSlug && b.instituteId === instituteId);

  useEffect(() => {

      // Scroll to top when page loads
    window.scrollTo(0, 0);

    document.title = blog.title;

    let meta = document.querySelector('meta[name="description"]');

    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.content = blog.metaDescription || "";
  }, [blog]);

  
  if (!blog || !info) {
    return (
      <section className="container py-5 text-center">
        <h2>Blog not found</h2>
        <Link to="/Blog" className="btn btn-primary">Back to Blogs</Link>
      </section>
    );
  }

 
  //const API_BASE_URL = "https://localhost:44340";
  const API_BASE_URL = "https://api.dnetpedia.com";

  const handleSubmit = async (e) => {
  e.preventDefault();

  setIsSending(true);
  setStatusMessage("");

  const formData = new FormData(form.current);

  const payload = {
    instituteName: info.name,
    blogTitle: blog.title,
    name: formData.get("user_name"),
    email: formData.get("user_email"),
    phone: formData.get("user_phone"),
    message: formData.get("message"),
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/feedback/sendcontact`,
      payload
    );

    if (response.status === 200) {
      setStatusMessage("Message sent successfully!");
      form.current.reset();
    } else {
      setStatusMessage("Something went wrong. Please try again.");
    }
  } catch (error) {
    console.error(error);
    setStatusMessage("Failed to send message. Please try again later.");
  } finally {
    setIsSending(false);
  }
};




  return (
    <>
      <article className="blog-post">
        <section className="Subpage_Hero blog-detail-hero">
          <div className="container">
            <div className="text-lg-start text-center">
              <h1>{blog.title}</h1>
              <p className="blog-meta">{info.name} • {blog.date}</p>
            </div>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/Blog">Institutes</Link></li>
                <li className="breadcrumb-item">
                  <Link to={`/Blog/${instituteId}`}>{info.name}</Link>
                </li>
                <li className="breadcrumb-item active">Detail</li>
              </ol>
            </nav>
          </div>
        </section>

        <section className="blog-detail-content">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <img 
                  src={`/assets/images/Courses/${blog.mainImage}`} 
                  alt={blog.title} 
                  className="w-100 mb-4 blog-main-img" 
                />
                
                <div className="blog-text-wrapper">
                  {blog.content.map((item, index) => {
                    //if (item.type === 'p') return <p key={index}>{item.text}</p>;
                       if (item.type === 'p') {
                         return (
                           <p
                             key={index}
                             dangerouslySetInnerHTML={{ __html: item.text }}
                           />
                         );
                       }
                    if (item.type === 'h2') return <h2 key={index}>{item.text}</h2>;
                    if (item.type === 'list') return (
                      <ol key={index}>
                        {item.items.map((li, i) => <li key={i}>{li}</li>)}
                      </ol>
                    );

                    //Handle Inline Images
                    if (item.type === 'image') {
                  return (
                      <figure key={index} className="my-4 text-center">
                          <img 
                              src={`/assets/images/Courses/${item.src}`} 
                              alt={item.alt || blog.title} 
                              className="w-100 rounded shadow-sm inline-blog-img" 
                          />
                          {item.caption && (
                              <figcaption className="text-muted mt-2 small">
                                  {item.caption}
                              </figcaption>
                          )}
                      </figure>
                  );
              }

                    return null;
                  })}

                  {/* FAQ Section - Only shows if data exists */}
                  {blog.faqs && (
                    <div className="faq-wrapper mt-5 p-4 bg-light">
                      <h3 className="mb-4">Frequently Asked Questions (FAQ)</h3>
                      {blog.faqs.map((faq, i) => (
                        <div key={i} className="mb-3">
                          <p className="fw-bold mb-1">{i + 1}. {faq.q}</p>
                          <p className="ps-3">{faq.a}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  <hr className="my-5" />

                  {/* CONTACT FORM SECTION */}
                  <div className="blog-contact-form p-4 border rounded shadow-sm bg-white">
                    <h3>Quick Inquiry</h3>
                    <p>Have questions about {info.name}? Send us a message.</p>
                    
                    <form ref={form} onSubmit={handleSubmit} >
                      {/* Hidden field to know which school/page the inquiry came from */}
                      <input type="hidden" name="institute_name" value={info.name} />
                      <input type="hidden" name="blog_title" value={blog.title} />

                      <div className="mb-3">
                        <label className="form-label">Full Name</label>
                        <input type="text" name="user_name" className="form-control" placeholder="Your Name" required />
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Email Address</label>
                          <input type="email" name="user_email" className="form-control" placeholder="name@example.com" required />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Phone Number</label>
                          <input type="tel" name="user_phone" className="form-control" placeholder="Your Phone" required />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Message</label>
                        <textarea name="message" className="form-control" rows="4" placeholder="How can we help you?" required></textarea>
                      </div>

                      <button type="submit" className="btn btn-primary w-100" disabled={isSending}>
                        {isSending ? "Sending..." : "Send Message"}
                      </button>

                      {statusMessage && (
                        <div className={`mt-3 alert ${statusMessage.includes("successfully") ? "alert-success" : "alert-danger"}`}>
                          {statusMessage}
                        </div>
                      )}
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
    </>
  );
};

export default BlogDetail;